var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appLoaded)?_c('v-layout',{staticClass:"header",attrs:{"row":"","wrap":"","align-start":""}},[_c('v-img',{staticClass:"logo",attrs:{"src":_vm.appLogo,"contain":"","title":_vm.appTitle,"height":"50"},on:{"click":_vm.goTo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }